import React, { forwardRef } from "react"
import { Button as AntButton } from "antd"
import tw from "twin.macro"

export default forwardRef(function Button({ disabled, ...props }, ref) {
    return (
        <AntButton
            {...props}
            ref={ref}
            disabled={disabled}
            css={[
                tw`rounded shadow-base text-primary`,
                tw`bg-white hover:bg-gray200! active:bg-gray300!`,
                tw`border-none h-11 px-4 py-3 transition-colors`,
                disabled &&
                    tw`text-[#A4B2C8]! bg-white! hover:bg-white! active:bg-white! shadow-base!`
            ]}
        />
    )
})
